import { useNavigate } from 'react-router-dom'
import type { Site } from '../../types'

interface Props {
  site: Site
  cameraCount?: number
  gatewayCount?: number
}

export function SiteCard({ site, cameraCount, gatewayCount }: Props) {
  const navigate = useNavigate()

  return (
    <div
      onClick={() => navigate(`/sites/${site.id}`)}
      className="bg-white border border-gray-200 rounded-xl p-4 cursor-pointer hover:shadow-md hover:border-gray-300 transition-all"
    >
      <div className="flex items-start justify-between mb-3">
        <div>
          <h3 className="font-semibold text-gray-900">{site.name}</h3>
        </div>
        {site.group_name && (
          <span className="text-[10px] px-2 py-0.5 rounded-full bg-gray-100 text-gray-500 font-medium">
            {site.group_name}
          </span>
        )}
      </div>

      <div className="flex items-center gap-3 text-xs text-gray-400">
        <span>{cameraCount ?? 0} cameras</span>
        {(gatewayCount ?? 0) > 0 && <span>{gatewayCount} gateways</span>}
      </div>
    </div>
  )
}
